import actions from './actions.js';
import mutations from './mutations.js';
import state from './state.js';
import persist from "./persist";

import StateMachine from '@rankers/lib/state_machine';

export default new StateMachine({
    name: 'OnlineApp',
    actions,
    mutations,
    state,
    persist,
    persistentStorageKey: 'RANKERS_ONLINE_APP__STORE',
    persistentStore: window.localStorage,
});